import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-work-grp',
  templateUrl: './work-grp.component.html',
  styleUrls: ['./work-grp.component.css']
})
export class WorkGrpComponent implements OnInit {
    workGrpKeyno;

    public edit?: Edit;

    public selectListFactories: FactoryItem[] = [];

    public factoryButtons: FormButton[] = [
        { id: 'list', type: 'primary', icon: 'fas fa-bars', goto: 'factories' }
    ];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.workGrpKeyno = this.stateService.getStateParams()['workgrp_keyno'];
    }

    private async loadEdit() {
        if (!!this.workGrpKeyno) {
            this.edit = (await this.datatask.Post(2022, { workgrp_keyno: this.workGrpKeyno }))[0];
        }
    }

    private async loadFactories(): Promise<void> {
        this.selectListFactories = await this.datatask.Post(2024);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2023, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadFactories();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    workgrp_keyno: number;
    workgrp_name: string;
    active: number;
    factory_id: string;
}

interface FactoryItem {
    factory_id: string;
    factory_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('workGrp', {
//        templateUrl: 'views/components/views/workGrp/workGrp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'workGrpService', 'labourPositionService', function ($stateParams, stateService, modalService, translateService, workGrpService, labourPositionService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let workGrpKeyno = $stateParams.workgrp_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                factoryButtons: [
//                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('factories') }
//                ],
//                edit: {},
//                selectListFactories: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await workGrpService.getEdit({ workgrp_keyno: workGrpKeyno }))[0];
//            }

//            async function loadSelectFactories() {
//                vm.model.selectListFactories = (await labourPositionService.listSelectFactories());
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                workGrpService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadSelectFactories();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
